<section class="container-fluid section-login" role="main" xmlns="http://www.w3.org/1999/html">
  <span style="font-weight: bold;">Password reset instructions have been sent to the email on file.</span> <br />
  <div class="no-padding-bottom"><a [routerLink]="['/login']" target="_self">Login</a></div>
  <div class="mt-10">If you did not receive an email please check your spam folder or check your credentials.</div>
</section>
